<div class="first-row">
    {{'app.title' | translate}}
</div>
<div class="second-row">
    <div class="form-container">
        <app-language></app-language>
        <router-outlet></router-outlet>
    </div>
</div>
<div class="third-row">
</div>